module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('router-view'), _vm._v(" "), _c('div', {
    staticClass: "accomodation-info"
  }, [(_vm.showModal()) ? _c('Modal', [_c('router-view')], 1) : _vm._e(), _vm._v(" "), _c('Timeline', {
    attrs: {
      "steps": _vm.timelineSteps
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "left-col default-image",
    style: ((_vm.unit && (_vm.unit.image || (_vm.unit.pool && _vm.unit.pool.image))) ? 'background-image:url(' + (_vm.unit && (_vm.unit.image || (_vm.unit.pool && _vm.unit.pool.image))) + ')' : 'background-size: cover;')
  }), _vm._v(" "), _c('div', {
    staticClass: "right-col"
  }, [_c('AccomodationPeriodConfirm', {
    attrs: {
      "unit": _vm.unit,
      "arrival": _vm.arrival,
      "departure": _vm.departure
    },
    on: {
      "gotprice": _vm.setExternalSuccess
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }), _vm._v(" "), _c('h1', [_vm._v("\n      " + _vm._s((_vm.unit.display_name || _vm.unit.description_title)) + "\n      "), (_vm.unit.subtitle) ? _c('i', [_vm._v(_vm._s(_vm.unit.subtitle))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "description",
    domProps: {
      "innerHTML": _vm._s(_vm.unit.description_short || _vm.unit.description_longer)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "booking-box"
  }, [_c('h2', [_vm._v("Välj antal resenärer")]), _vm._v(" "), _c('p', [_vm._v("För att göra bokningen enklare behöver du fylla i antalet resenärer.\n      ")]), (_vm.SITE_CONFIG.skipass.ages.adults) ? _c('div', {
    staticStyle: {
      "padding-right": "4px"
    }
  }, [_c('b', [_vm._v("Vuxen "), _c('span', [_vm._v("(" + _vm._s(_vm.SITE_CONFIG.skipass.ages.adults) + " år):")])]), _vm._v(" "), _c('CounterButton', {
    staticClass: "counter-button small",
    attrs: {
      "inline": true,
      "count": _vm.adults,
      "min": 0,
      "suffix": "st"
    },
    on: {
      "changedCount": function($event) {
        return _vm.changeAdults($event)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.SITE_CONFIG.skipass.ages.youths) ? _c('div', {
    staticStyle: {
      "padding-right": "4px"
    }
  }, [_c('b', [_vm._v("Ungdom "), _c('span', [_vm._v("(" + _vm._s(_vm.SITE_CONFIG.skipass.ages.youths) + " år):")])]), _vm._v(" "), _c('CounterButton', {
    staticClass: "counter-button small",
    attrs: {
      "inline": true,
      "count": _vm.youths,
      "min": 0,
      "suffix": "st"
    },
    on: {
      "changedCount": function($event) {
        return _vm.changeYouths($event)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.SITE_CONFIG.skipass.ages.seniors) ? _c('div', {
    staticStyle: {
      "padding-right": "4px"
    }
  }, [_c('b', [_vm._v("Senior "), _c('span', [_vm._v("(" + _vm._s(_vm.SITE_CONFIG.skipass.ages.seniors) + " år):")])]), _vm._v(" "), _c('CounterButton', {
    staticClass: "counter-button small",
    attrs: {
      "inline": true,
      "count": _vm.seniors,
      "min": 0,
      "suffix": "st"
    },
    on: {
      "changedCount": function($event) {
        return _vm.changeSeniors($event)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.SITE_CONFIG.skipass.ages.children) ? _c('div', {
    staticStyle: {
      "padding-right": "4px"
    }
  }, [_c('b', [_vm._v("Barn "), _c('span', [_vm._v("(" + _vm._s(_vm.SITE_CONFIG.skipass.ages.children) + " år):")])]), _vm._v(" "), _c('CounterButton', {
    staticClass: "counter-button small",
    attrs: {
      "inline": true,
      "count": _vm.children,
      "min": 0,
      "suffix": "st"
    },
    on: {
      "changedCount": function($event) {
        return _vm.changeChildren($event)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })], 1) : _vm._e()]), _vm._v(" "), _c('button', {
    class: {
      disabled: !_vm.validated()
    },
    on: {
      "click": _vm.addToCart
    }
  }, [_vm._v(_vm._s(_vm.cartAccomodationObject.confirmed ? 'Spara' : 'Lägg till i varukorg') + " "), (!_vm.cartAccomodationObject.confirmed) ? _c('icon', {
    attrs: {
      "name": "cart-white",
      "scale": 1.5
    }
  }) : _vm._e()], 1)], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1dcc39fc"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Pages/Accomodation/AccomodationsConfirm.vue
// module id = 898
// module chunks = 0